import { NgModule, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { UpgradeModule } from '@angular/upgrade/static';
import { IbGiftCardsPaymentsComponent } from './ib-gift-cards-payments.component';
import { NgReactModule } from '@src/app/react/ng-react.module';
import { IbGiftCardsPaymentsService } from './ib-gift-cards-payments.service';
//import { IbGiftCardsPaymentsService } from './ib-gift-cards-payments.service';

@NgModule({
    schemas:[CUSTOM_ELEMENTS_SCHEMA],
    declarations: [
        IbGiftCardsPaymentsComponent
    ],
    exports: [
        IbGiftCardsPaymentsComponent
    ],
    imports: [
        CommonModule,
        UpgradeModule,
        TranslateModule,
        NgReactModule
    ],
    providers: [
        {
            provide: 'localStorageService',
            useFactory: ($injector: any) => $injector.get('localStorageService'),
            deps: ['$injector']
        }, {
            provide: 'NewMainHeaderFacade',
            useFactory: ($injector: any) => $injector.get('NewMainHeaderFacade'),
            deps: ['$injector']
        }, {
            provide: 'CommonsModalService',
            useFactory: ($injector: any) => $injector.get('CommonsModalService'),
            deps: ['$injector']
        }, {
            provide: 'CurrencyService',
            useFactory: ($injector: any) => $injector.get('CurrencyService'),
            deps: ['$injector']
        }, {
            provide: 'RedirectionLandingService',
            useFactory: ($injector: any) => $injector.get('RedirectionLandingService'),
            deps: ['$injector']
        },
        {
            provide: 'CommonsGenericProxy',
            useFactory: ($injector: any) => $injector.get('CommonsGenericProxy'),
            deps: ['$injector']
        },
        // {
        //     provide: 'IbGiftCardsPaymentsService',
        //     useFactory: ($injector: any) => $injector.get('IbGiftCardsPaymentsService'),
        //     deps: ['$injector']
        // }
        IbGiftCardsPaymentsService
    ]
})

export class IbGiftCardsPaymentsModule { }
export { IbGiftCardsPaymentsComponent } from './ib-gift-cards-payments.component';
